const LabelMenuMixin = {
    methods: {
        closeMenu: function() {
            this.$emit('close')
        }
    }
}

export default LabelMenuMixin